import React from 'react';
import {
  FormattedMessage,
  injectIntl,
  IntlShape,
  WrappedComponentProps,
} from 'react-intl';
import styled from '@emotion/styled';
import { Header, Helmet, Footer, ThemeLayout } from '@components';
import { Spacer, Container, Main } from 'ech-components/src/helpers';
import { rem } from 'polished';
import {
  colors,
  mixins,
  text,
} from 'ech-components/src/core/styles/theme/default';
import { H1 } from 'ech-components/src/primitives';
import SvgPageNotFound from 'ech-components/src/primitives/IconSVG/animated/PageNotFound';
import { createLanguageObject } from '@scripts/utils/domain';

const StyledNothingHere = styled.div`
  ${text.lead1};
  color: ${colors.nightBlue900};
  text-align: center;

  ${H1} {
    margin-top: ${rem(80)};
    margin-bottom: ${rem(80)};
  }
`;

const StyledSvgPageNotFound = styled(SvgPageNotFound)`
  width: ${rem(80)};
  height: ${rem(80)};
  margin-left: auto;
  margin-right: auto;

  ${mixins.MQ('medium')} {
    width: ${rem(160)};
    height: ${rem(160)};
  }
`;

const NotFoundPage = ({ intl, pageContext }: NotFoundPageProps) => (
  <ThemeLayout
    customTheme={{
      campaign: {
        key: pageContext.campaignKey,
      },
    }}
  >
    <Helmet
      locale={intl.locale}
      langObj={createLanguageObject({ intl: intl, root: '', slug: '' })}
      matomo={pageContext.matomo}
    />
    <Header
      langObj={createLanguageObject({ intl: intl, root: '', slug: '' })}
    />
    <Main>
      <Container>
        <StyledNothingHere>
          <H1>404</H1>
          <StyledSvgPageNotFound />
          <Spacer space="theta" />
          <FormattedMessage id="page.404" />
          <Spacer space="lambda" />
        </StyledNothingHere>
      </Container>
    </Main>
    <Footer
      langObj={createLanguageObject({ intl: intl, root: '', slug: '' })}
    />
  </ThemeLayout>
);

export type NotFoundPageProps = {
  intl: IntlShape;
  pageContext: any;
} & WrappedComponentProps;

export default injectIntl(NotFoundPage);
